<!-- 成绩查询 -->
<template>
  <div class="el-scoreQuery">
    <el-row class="page_content">
      <h1 class="head_title">成绩查询</h1>
      <el-form
        ref="form"
        :model="form"
        label-width="80px"
        v-if="!this.$strExistHostnameOnce(['localhost', 'hbjz','lfjtysxx'])"
      >
        <el-form-item label="学期">
          <el-select
            v-model="form.region"
            :filterable="true"
            @change="selectScore"
            placeholder="请选择学期"
          >
            <el-option label="所有" value=""></el-option>
            <template v-for="(item, index) in semesterList">
              <el-option :key="index" :label="item" :value="item"></el-option>
            </template>
          </el-select>
        </el-form-item>
      </el-form>
      <el-table
        :data="tableData"
        border
        :default-sort="{ prop: 'semesters', order: 'ascending' }"
        style="width: 100%"
      >
        <el-table-column
          prop="semesters"
          header-align="center"
          align="center"
          width="150"
          sortable
          label="学期"
          v-if="!this.$strExistHostnameOnce(['localhost', 'hbjz','lfjtysxx'])"
        >
        </el-table-column>
        <el-table-column
          prop="courseName"
          header-align="center"
          align="center"
          label="课程名称"
        >
        </el-table-column>
        <el-table-column
          prop="studyVideoGrade"
          header-align="center"
          align="center"
          label="学习"
          width="120"
        >
        </el-table-column>
        <el-table-column
          prop="homeworkGrade"
          header-align="center"
          align="center"
          label="作业"
          width="120"
        >
        </el-table-column>
        <el-table-column
          prop="examGrade"
          header-align="center"
          align="center"
          label="考试"
          width="120"
        >
        </el-table-column>
        <el-table-column
          prop="makeUpExamGrade"
          header-align="center"
          align="center"
          label="补考"
          width="120"
        >
        </el-table-column>
        <el-table-column
          v-for="(item, index) in headList"
          :key="index"
          :prop="item.field"
          header-align="center"
          align="center"
          :label="item.title"
        >
        </el-table-column>
        <el-table-column
          prop="totalGrade"
          header-align="center"
          align="center"
          label="总分"
          width="120"
        >
        </el-table-column>
      </el-table>
      <div
        class="block"
        style="text-align: center; bottom: 0; width: 96%; margin-bottom: 20px"
      >
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage1"
          :page-size="limit"
          :hide-on-single-page="true"
          layout="total, prev, pager, next"
          :total="total"
        >
        </el-pagination>
      </div>
    </el-row>
    <el-dialog
      :title="dialogInfo.title"
      :visible.sync="dialogVisible"
      width="700px"
    >
      <p style="font-size: 18px; text-indent: 2em">{{ dialogInfo.date }}</p>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "ScoreQuery",
  data() {
    return {
      form: {
        region: "",
      },
      tableData: [],
      dialogInfo: {},
      dialogVisible: false,
      submitBut: false,
      currentPage1: 1,
      total: 0,
      limit: 1000,
      page: 1,
      headList: [],
      semesterList: ['1','2','3','4','5','6','7','8','9','10'],
      loading: true,
      semester: "",
    };
  },
  created() {
    this.getAchievementItemTableHeader();
    // this.getSemester();
  },
  methods: {
    selectScore(v) {
      this.page = 1;
      this.getInfo();
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.page = val;
      this.getInfo();
    },
    getInfo() {
      //获取分页数据
      if (!this.$isEmpty(this.form.region)) {
        this.semester = this.form.region;
        // this.semester = this.form.region.replace("学期 第","___").replace("批次","").replace("学期", "").replace("第", "");
      } else {
        this.semester = "";
      }
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.$store
        .dispatch("user/getGrades", {
          limit: this.limit,
          page: this.page,
          semester: this.semester,
        })
        .then((ret) => {
          if (ret.code == 0) {
            // let tableList = [];
            // for(let i in ret.data){
            //     ret.data[i].semesters = Number(ret.data[i].semesters.replace(/[^0-9]/ig,""));
            //     tableList.push(ret.data[i]);
            // }
            // console.log("渲染时",tableList);
            this.tableData = ret.data;
            loading.close();
            this.total = ret.count;
            // this.loading = false;
          } else {
            loading.close();
            this.$message({
              message: ret.msg,
              type: "warning",
            });
          }
        })
        .catch(() => {
          loading.close();
        });
    },
    getAchievementItemTableHeader() {
      //获取动态表头
      this.$store.dispatch("user/getAchievementItemTableHeader").then((ret) => {
        if (ret.code == 0) {
          this.headList = ret.data;
          this.getInfo();
        } else {
          this.$message({
            message: ret.msg,
            type: "warning",
          });
        }
      });
    },
    getSemester() {
      //获取学期信息
      this.$store.dispatch("user/getSemester").then((ret) => {
        if (ret.code == 0) {
          this.semesterList = ret.data;
        } else {
          this.$message({
            message: ret.msg,
            type: "warning",
          });
        }
      });
    },
  },
};
</script>
<style  lang="less">
@import "../styles/base.less";
.el-scoreQuery {
  .wd {
    color: @red;
  }
  .el-dialog__body {
    border-top: 1px solid #ebeef5;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/ScoreQuery.vue